import { Fragment, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { config_url } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";

function AddCategory() {
  const [categorie, setCategorie] = useState("");

  const addGroupe = () => {
    axios
      .post(`${config_url}/api/categories`, {
        categorie,
      })
      .then((res) => {
        toast.success("Categorie Name Is Added !!");
        setCategorie("");
      });
  };
  return (
    <Fragment>
      <form className="flex items-center justify-center gap-8">
        <TextField
          onChange={(e) => setCategorie(e.target.value)}
          id="outlined-basic"
          label="Category Name"
          variant="outlined"
        />
        <Button variant="contained" onClick={() => addGroupe()}>
          Send
        </Button>
      </form>
    </Fragment>
  );
}

export default AddCategory;
